export default __webpack_public_path__ + "static/media/writingsretro.552d3bca.png";